import React from "react";

const ClientInfo = React.createContext({
  clientInfo: {}
});

export default ClientInfo;
